import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useSearchParams } from "react-router-dom";
import { InsurancePanel } from "@/pages/Insurance";
import { DocumentsPanel } from "@/pages/Documents";
import { TrainingPanel } from "@/pages/Training";
import { LinksPanel } from "@/pages/Links";
import { TradeUnionsPanel } from "@/pages/TradeUnions";
import { VehicleCheckPanel } from "@/pages/VehicleCheck";
import { ComplianceDocsPanel } from "@/pages/ComplianceDocs";
import { RemindersPanel } from "@/pages/Reminders";
import { TeamPanel } from "@/pages/Team";
import { InvoicesPanel } from "@/pages/Invoices";
import { ScanInboxPanel } from "@/pages/ScanInbox";

const VALID = ["scaninbox", "insurance", "vehiclecheck", "documents", "compliance", "training", "invoices", "links", "unions", "reminders", "team"];

export default function Office() {
  const [params] = useSearchParams();
  const initial = VALID.includes(params.get("tab")) ? params.get("tab") : "insurance";
  return (
    <div data-testid="office-page">
      <div className="mb-6">
        <p className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">Compliance</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight text-slate-900 mt-1">Office</h1>
        <p className="text-slate-500 text-sm mt-1">Scan inbox, insurance, vehicle checks, documents, training, invoices, links, unions, reminders &amp; team</p>
      </div>
      <Tabs defaultValue={initial}>
        <TabsList className="mb-6 flex-wrap h-auto">
          <TabsTrigger value="scaninbox" data-testid="tab-scaninbox">Scan Inbox</TabsTrigger>
          <TabsTrigger value="insurance" data-testid="tab-insurance">Insurance</TabsTrigger>
          <TabsTrigger value="vehiclecheck" data-testid="tab-vehiclecheck">Vehicle Check</TabsTrigger>
          <TabsTrigger value="documents" data-testid="tab-documents">Documents</TabsTrigger>
          <TabsTrigger value="compliance" data-testid="tab-compliance">Compliance Docs</TabsTrigger>
          <TabsTrigger value="training" data-testid="tab-training">Training</TabsTrigger>
          <TabsTrigger value="invoices" data-testid="tab-invoices">Invoices</TabsTrigger>
          <TabsTrigger value="links" data-testid="tab-links">Links</TabsTrigger>
          <TabsTrigger value="unions" data-testid="tab-unions">Trade Unions</TabsTrigger>
          <TabsTrigger value="reminders" data-testid="tab-reminders">Reminders</TabsTrigger>
          <TabsTrigger value="team" data-testid="tab-team">Team</TabsTrigger>
        </TabsList>
        <TabsContent value="scaninbox"><ScanInboxPanel /></TabsContent>
        <TabsContent value="insurance"><InsurancePanel embedded /></TabsContent>
        <TabsContent value="vehiclecheck"><VehicleCheckPanel /></TabsContent>
        <TabsContent value="documents"><DocumentsPanel embedded /></TabsContent>
        <TabsContent value="compliance"><ComplianceDocsPanel /></TabsContent>
        <TabsContent value="training"><TrainingPanel embedded /></TabsContent>
        <TabsContent value="invoices"><InvoicesPanel embedded /></TabsContent>
        <TabsContent value="links"><LinksPanel /></TabsContent>
        <TabsContent value="unions"><TradeUnionsPanel /></TabsContent>
        <TabsContent value="reminders"><RemindersPanel embedded /></TabsContent>
        <TabsContent value="team"><TeamPanel embedded /></TabsContent>
      </Tabs>
    </div>
  );
}
